import { render, staticRenderFns } from "./AdditionalEvaluation.vue?vue&type=template&id=3b9e7b85"
import script from "./AdditionalEvaluation.vue?vue&type=script&lang=js"
export * from "./AdditionalEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports